function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "assignment_turned_in-24px",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_251",
  "data-name": "Trazado 251",
  d: "M0,0H31.5V31.5H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_252",
  "data-name": "Trazado 252",
  d: "M23,3.55H17.775a3.711,3.711,0,0,0-7.05,0H5.5A2.533,2.533,0,0,0,3,6.1V23.95A2.533,2.533,0,0,0,5.5,26.5H23a2.533,2.533,0,0,0,2.5-2.55V6.1A2.533,2.533,0,0,0,23,3.55Zm-8.75,0A1.275,1.275,0,1,1,13,4.825,1.266,1.266,0,0,1,14.25,3.55ZM10.863,20.495l-3.238-3.3a1.288,1.288,0,0,1,0-1.8,1.228,1.228,0,0,1,1.762,0l2.363,2.4,7.35-7.5a1.228,1.228,0,0,1,1.763,0,1.288,1.288,0,0,1,0,1.8l-8.238,8.4A1.228,1.228,0,0,1,10.863,20.495Z",
  transform: "translate(1.5 0.5)",
  fill: "#dde8f1"
}));

var SvgAssignment = function SvgAssignment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.5,
    height: 31.5,
    viewBox: "0 0 31.5 31.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssignment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/assignment.5a5ade1f.svg";
export { ForwardRef as ReactComponent };